<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstBus"
		[loading]="loading == true || TableLoading == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedBuses"
		dataKey="BusID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--BusNbr-->
				<th>
					<p-columnFilter type="text" field="BusNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusDesc-->
				<th>
					<p-columnFilter type="text" field="BusDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox (click)="onCheckClick()"></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="BusNbr">Bus Number<p-sortIcon field="BusNbr"></p-sortIcon></th>
				<th pSortableColumn="BusDesc">Description<p-sortIcon field="BusDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Bus>
			<tr [pSelectableRow]="Bus" (dblclick)="onRowDblClick(Bus)">
				<td>
					<p-tableCheckbox [pSelectableRow]="Bus" [value]="Bus"></p-tableCheckbox>
				</td>

				<td
					*ngFor="let col of cols"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="Bus.Active == true ? 'Black' : 'Red'"
				>
					{{ Bus[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
